export const SET_PLATFORM = "SET_PLATFORM";
